import { CastctlFeatureSelection } from './types';

type CastctlSupportedFeature = keyof CastctlFeatureSelection;

export const CASTCTL_SUPPORTED_FEATURES: CastctlSupportedFeature[] = [
  'workloadAutoscaler',
  'autoscaler',
  'reliabilityMetrics',
];
